import { type InteractionLogEntry } from '../../../types/interaction-log-data';

export const getParametersForEventType = (log: InteractionLogEntry): Record<string, unknown> | undefined => {
  const { EventType, LogData } = log;

  switch (EventType) {
    case 'Parameters':
      return LogData.Action?.Parameters;

    case 'ExecutionResult':
      // Return specific parameters for ExecutionResult events
      return LogData.Action?.Parameters
        ? {
            ExecutionResult: LogData.Action.ExecutionResult,
            ...LogData.Action.Parameters
          }
        : undefined;

    case 'FlowStart':
      // Return flow-related parameters
      return LogData.Action?.Parameters
        ? {
            FlowName: LogData.ResourceName,
            ...LogData.Action.Parameters
          }
        : undefined;

    case 'FlowEnd':
      // Return end-related parameters
      return LogData.Action?.Parameters;

    // Add more EventTypes as needed
    default:
      return undefined;
  }
};
